import PostPreviewComponent from "./PostPreviewComponent";

export default PostPreviewComponent;
